import React, { useEffect, useState, useRef, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Header from "../../layouts/Header";
import "../../assets/styles/local/ProvisionalDetails.css";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import Kebab from "../../assets/icons/Kebab Calculations.svg";
import delete1 from "../../assets/icons/Group 2723.svg";
import edit from "../../assets/icons/edit.svg";
import duplicate from "../../assets/icons/Duplicate.svg";
import arrow from "../../assets/icons/down arrow.svg";
import cross from "../../assets/icons/x-circle-3.svg";
import cross2 from "../../assets/icons/Xicon.svg";
import { FetchProvisional, ProductDropdown } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { ROLES } from "../../utils/helpers/userRole";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ProvisionalDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const popupRef = useRef(null);
  const heightRef = useRef(null);

  const projectId = window.localStorage.getItem("projectid");
  const roleAccess = window.localStorage.getItem("roleid");

  const [querystring, setQuerystring] = useState("");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  // VARIABLES START //
  const [allSectionsHeight, setAllSectionsHeight] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [productList, setProductList] = useState([]);
  const [fullProductList, setFullProductList] = useState([]);
  const [quoteId, setQuoteId] = useState("");
  const [quoteCode, setQuoteCode] = useState("");
  const [margin, setMargin] = useState("");
  const [uLaborCost, setULaborCost] = useState("");
  const [sectionList, setSectionList] = useState([]);
  const [openSectionIndex, setOpenSectionIndex] = useState(null);
  const [total, setTotal] = useState("0");
  const [pageFunction, setPageFunction] = useState("");
  const [backLocation, setBackLocation] = useState("");
  const [showAllSections, setShowAllSections] = useState(false);
  // VARIABLES END //

  const fetchProvisionalRes = useSelector(
    (state) => state.user.fetchProvisionalRes
  );

  useEffect(() => {
    dispatch(FetchProvisional(projectId));
  }, []);

  useEffect(() => {
    if (fetchProvisionalRes?.status === true) {
      setSectionList(fetchProvisionalRes?.data?.sections);
      setTotal(fetchProvisionalRes?.data?.total);
      setMargin(fetchProvisionalRes?.data?.margin);
      setULaborCost(fetchProvisionalRes?.data?.unitlabelcost);
    }
  }, [fetchProvisionalRes]);

  // sarthak code start

  const fetchProductDropdown = useSelector(
    (state) => state.user.fetchProductDropdown
  );

  const onDragEnd = (result) => {
    if (result?.destination !== null) {
      let list = [...sectionList];
      let source = list.slice(
        result?.source?.index,
        result?.source?.index + 1
      )[0];
      list.splice(result?.source?.index, 1);
      list.splice(result?.destination?.index, 0, source);
      list.map((section, index) => {
        section["indexPosition"] = index;
      });
      setSectionList([...list]);
      if (openSectionIndex === null) return;
      if (openSectionIndex === result?.source?.index)
        return setOpenSectionIndex(result?.destination?.index);
      if (
        openSectionIndex !== result?.source?.index &&
        openSectionIndex === result?.destination?.index
      )
        return setOpenSectionIndex(result?.source?.index);
      if (openSectionIndex !== result?.destination?.index) return;
      setOpenSectionIndex(result?.destination?.index);
    }
  };

  useEffect(() => {
    setAllSectionsHeight(heightRef?.current?.clientHeight);
  }, []);

  useEffect(() => {
    dispatch(ProductDropdown());
    setQuoteCode(history.location?.state?.split("@@")[0]);
    setQuoteId(history.location?.state?.split("@@")[1]);
    setPageFunction(history.location?.state?.split("@@")[2]);
    setBackLocation(history.location?.state?.split("@@")[3]);
  }, []);

  useEffect(() => {
    if (fetchProductDropdown?.status === true) {
      setProductList(fetchProductDropdown?.data);
      setFullProductList(fetchProductDropdown?.data);
    }
  }, [fetchProductDropdown]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef]);

  let financialTab = history.location?.state?.split("@@")[3];
  let sectionNameFilter = sectionList?.find(
    (item) => item.sectionName === "EW - Extra Work"
  );

  useEffect(() => {
    if (
      sectionNameFilter?.sectionName === "EW - Extra Work" &&
      financialTab === "/financial"
    ) {
      setOpenSectionIndex(sectionNameFilter?.indexPosition);
    }
  }, [sectionNameFilter]);
  // sarthak code end

  const totalAllSection = useMemo(() => {
    return sectionList
      ? sectionList.reduce(
          (a, b) => a + b.subSections.reduce((x, y) => x + y.total, 0),
          0
        )
      : 0;
  }, [JSON.stringify(sectionList)]);

  const totalRealisation = useMemo(() => {
    return sectionList
      ? sectionList.reduce(
          (a, b) => a + b.subSections.reduce((x, y) => x + y.realisation, 0),
          0
        )
      : 0;
  }, [JSON.stringify(sectionList)]);

  return (
    <mainSection>
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div className="d-flex align-items-baseline flex-wrap gap-4">
            <div
              className="invoiceText ps-4"
              onClick={() => {
                history.push("/project");
              }}
            >
              {/* Projects */}
              {t("Projects")}
            </div>
            <div className="pt-2 d-flex pe-3" style={{ background: "#FFFFFF" }}>
              <p className="pt-1 ps-4 invoiceText2">
                {/* Project */}
                {t("Project")}
              </p>
              {/* <p className="pt-1 projectID ps-5"> &nbsp;{invoiceId} </p> */}
              <p className="pt-1 projectID ps-5"> &nbsp;12345 </p>
            </div>
          </div>
        }
      />

      <provisionalSection>
        <div className="provisionaltxt ps-5">
          <p>
            {/* PROVISIONALS */}
            {t("PROVISIONALS")}
          </p>
        </div>

        <div className="quote-cal-main-cont-pro px-5">
          <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
            <Droppable droppableId={123456} key={`droppable-${123456}`}>
              {(provided) => {
                return (
                  <div
                    key={`droppable-div-${123456}`}
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{ minHeight: `${5.5 * sectionList?.length}rem` }}
                  >
                    {sectionList?.map((section, index) => {
                      return (
                        <Draggable
                          key={`draggable-${section?.sectionid}`}
                          draggableId={section?.sectionid}
                          index={index}
                        >
                          {(provided) => {
                            return (
                              <SingleSection
                                provided={provided}
                                key={`${index}-${section?.sectionid}`}
                                productList={productList}
                                fullProductList={fullProductList}
                                setProductList={setProductList}
                                sectionid={section?.sectionid}
                                sectionName={section?.sectionName}
                                comment={section?.comment}
                                indexPosition={section?.indexPosition}
                                totalAmount={section?.totalAmount}
                                totalHours={section?.totalHours}
                                subsectiondetails={section?.subSections}
                                index={index}
                                openSectionIndex={openSectionIndex}
                                setOpenSectionIndex={setOpenSectionIndex}
                                sectionList={sectionList}
                                setSectionList={setSectionList}
                                vatTotal={total}
                                setVatTotal={setTotal}
                                showAllSections={showAllSections}
                                roleAccess={roleAccess}
                                quoteid={quoteId}
                                margin={margin}
                                uLaborCost={uLaborCost}
                                FetchTranslationList={FetchTranslationList}
                              />
                            );
                          }}
                        </Draggable>
                      );
                    })}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
          <div className="total-exc-vat">
            <p></p>
            <p>{t("Total Excl. VAT")}</p>
            <p></p>
            <p style={{ textAlign: "end" }}>
              {europeanFormatWithSymbol(totalAllSection)}
            </p>
            <p style={{ textAlign: "end" }}>
              {europeanFormatWithSymbol(totalRealisation)}
            </p>
          </div>
          <div className="cal-page-btns pb-4">
            <button
              className="cal-page-cancel"
              onClick={() => {
                history.goBack();
                // dispatch(deleteUpdateQuoteState());
              }}
            >
              {/* Cancel */}
              {t("Cancel ")}
            </button>
            <button
              className="cal-page-cancel cal-page-print"
              // onClick={() => {
              //   history.push(`/quote/${quoteId}/pdf`);
              // }}
            >
              {/* Print */}
              {t("Print")}
            </button>
            <button
              className="cal-page-change"
              onClick={() => {
                if (roleAccess === ROLES.VIEWER)
                  return handleGeneralNotification({
                    notificationType: "CUSTOM",
                    text: `You don't have permission to add/edit quotes.`,
                  });
                axiosInstance
                  .post(
                    `${API_URL}/api/quote/provisionals-sections`,
                    sectionList,
                  )
                  .then((res) => {
                    history.goBack();
                  });
              }}
            >
              {/* {pageFunction} */}
              {/* Save */}
              {t("Save")}
            </button>
          </div>
        </div>
      </provisionalSection>
    </mainSection>
  );
};

export default ProvisionalDetails;

const SingleSection = ({
  provided,
  key,
  productList,
  fullProductList,
  setProductList,
  sectionid,
  sectionName,
  comment,
  totalAmount,
  totalHours,
  subsectiondetails,
  index,
  openSectionIndex,
  setOpenSectionIndex,
  sectionList,
  setSectionList,
  vatTotal,
  setVatTotal,
  showAllSections,
  roleAccess,
  quoteid,
  margin,
  uLaborCost,
  FetchTranslationList,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showMaterialPopup, setShowMaterialPopup] = useState(false);
  const sectionHeightRef = useRef(null);
  const materialPopupRef = useRef(null);
  const [sectionHeight, setSectionHeight] = useState(0);
  const [material, setMaterial] = useState("");
  const [commentState, setCommentState] = useState(comment);
  const [showComment, setShowComment] = useState(false);
  const [totalHoursMain, setTotalHoursMain] = useState(totalHours);
  const [totalAmountMain, setTotalAmountMain] = useState(totalAmount);
  const [singleSectionName, setSingleSectionName] = useState(sectionName);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const t = (key) => FetchTranslationList?.[key] || "";

  const onDragEndSubSection = (result) => {
    if (result?.destination !== null) {
      let list = [...sectionList];
      let source = list[index]?.subsectiondetails.slice(
        result?.source?.index,
        result?.source?.index + 1
      )[0];
      list[index]?.subsectiondetails.splice(result?.source?.index, 1);
      list[index]?.subsectiondetails.splice(
        result?.destination?.index,
        0,
        source
      );
      list[index]?.subsectiondetails.map((section, index) => {
        section["indexPosition"] = index;
      });
      setSectionList([...list]);
    }
  };

  useEffect(() => {
    setSectionHeight(sectionHeightRef.current.clientHeight);
  });

  useEffect(() => {
    setTotalAmountMain(totalAmount);
  }, [sectionList]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        materialPopupRef.current &&
        !materialPopupRef.current.contains(event.target)
      ) {
        setShowMaterialPopup(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [materialPopupRef]);

  useEffect(() => {
    if (material) {
      let list = [...fullProductList];
      list = list?.filter((product) => {
        return product?.productPartName
          ?.toLowerCase()
          .startsWith(material.toLowerCase());
      });
      setProductList(list);
    } else {
      setProductList([...fullProductList]);
    }
  }, [material]);

  // useEffect(() => {
  //   if (subsectiondetails?.length > 0) {
  //     setSelectedProducts([...subsectiondetails]);
  //   }
  // }, []);

  const totalProvision = useMemo(() => {
    return subsectiondetails.reduce((a, b) => a + b.realisation, 0);
  });

  return (
    <div
      className="single-section-div"
      key={key}
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <div
        className="single-section-div-head-pro"
        {...provided.dragHandleProps}
      >
        <div className="invisible" style={{ position: "relative" }}>
          <img src={Kebab} onClick={() => setShowMenu(true)} />
          <div
            className="kebab-menu"
            style={{
              transform: showMenu ? "scale(1)" : "scale(0)",
              transitionDuration: "300ms",
            }}
          >
            <img
              src={Kebab}
              onClick={() => setShowMenu(false)}
              style={{ cursor: "pointer" }}
            />
            <div className="kebab-option-div">
              <section
                onClick={() => {
                  if (roleAccess === ROLES.VIEWER)
                    return handleGeneralNotification({
                      notificationType: "CUSTOM",
                      text: `You don't have permission to add/edit quotes.`,
                    });
                  // dispatch(DuplicateSection(sectionid));
                  setShowMenu(false);
                }}
              >
                <img src={duplicate} />
                <p>
                  {/* Duplicate */}
                  {t("Duplicate")}
                </p>
              </section>
              <section
                onClick={() => {
                  if (roleAccess === ROLES.VIEWER)
                    return handleGeneralNotification({
                      notificationType: "CUSTOM",
                      text: `You don't have permission to add/edit quotes.`,
                    });
                  setShowComment(true);
                  setShowMenu(false);
                }}
              >
                <img src={edit} />
                <p>Add Comment</p>
              </section>
              <section
                onClick={() => {
                  if (roleAccess === ROLES.VIEWER)
                    return handleGeneralNotification({
                      notificationType: "CUSTOM",
                      text: `You don't have permission to add/edit quotes.`,
                    });
                  // dispatch(DeleteSection(quoteid, sectionid));
                  setShowMenu(false);
                }}
              >
                <img src={delete1} />
                <p>
                  {/* Delete */}
                  {t("Delete")}
                </p>
              </section>
            </div>
          </div>
          <div
            className="comment-popup"
            style={{
              transform: showComment ? "scale(1)" : "scale(0)",
              transitionDuration: "300ms",
            }}
          >
            <div className="add-comment-flex">
              <p>Section Comment</p>
              <img
                src={cross}
                style={{ cursor: "pointer" }}
                onClick={() => setShowComment(false)}
              />
            </div>
            <textarea
              placeholder="Add a comment"
              className="comment-textarea"
              value={commentState}
              onChange={(e) => {
                setCommentState(e.target.value);
                let list = [...sectionList];
                list = list[index]["comment"] = e.target.value;
                setSectionList([...sectionList]);
              }}
            />
          </div>
        </div>
        <p className="total-h-text mb-0" style={{ fontWeight: "bold" }}>
          {(+index + 1)?.toString().padStart(2, "0")} -
          <input
            className="section-name-input"
            value={singleSectionName}
            onChange={(e) => {
              setSingleSectionName(e.target.value);
              let list = [...sectionList];
              list = list[index]["sectionName"] = e.target.value;
              setSectionList([...sectionList]);
            }}
          />
        </p>
        <div className="invisible" style={{ textAlign: "end" }}>
          <p className="total-h-text mb-0">Total Hours</p>
          <p className="total-h-text mb-0" style={{ fontWeight: "bold" }}>
            {totalHoursMain}
          </p>
        </div>
        <div style={{ textAlign: "end" }}>
          <p className="total-h-text mb-0">Total Provisional</p>
          <p className="total-h-text mb-0" style={{ fontWeight: "bold" }}>
            {europeanFormatWithSymbol(totalProvision)}
          </p>
        </div>
        <div style={{ textAlign: "end", cursor: "pointer" }}>
          <img
            src={arrow}
            onClick={() => {
              if (openSectionIndex === index) return setOpenSectionIndex(null);
              setOpenSectionIndex(index);
            }}
            style={{
              transform:
                index === openSectionIndex ? "rotate(180deg)" : "rotate(0)",
              transitionDuration: "300ms",
            }}
          />
        </div>
      </div>
      <div style={{ transitionDuration: "500ms" }}>
        {/* <div style={{ height: `${sectionHeight}px`, transitionDuration: "500ms" }}> */}
        <div
          ref={sectionHeightRef}
          style={{
            display:
              index === openSectionIndex || showAllSections ? "block" : "none",
          }}
        >
          <div
            className="single-sec-cont-head-pro"
            style={{ cursor: "default" }}
          >
            <div></div>
            <p>Material</p>
            <p style={{ textAlign: "center" }}>Qty</p>
            <p style={{ textAlign: "end" }}>U. Price</p>
            <p style={{ textAlign: "end", color: "#323232" }}>
              Material <br />
              Total
            </p>
            <p style={{ textAlign: "end" }}>Hours</p>
            <p style={{ textAlign: "end" }}>U. Price</p>
            <p style={{ textAlign: "end", color: "#323232" }}>Hours Total</p>
            {/* <p style={{ textAlign: "center" }}>Margin</p> */}
            <p style={{ textAlign: "center" }}></p>
            <p style={{ textAlign: "end", color: "#323232" }}>Total</p>
            <p style={{ textAlign: "end" }}>Realisation</p>
          </div>
          <DragDropContext onDragEnd={(result) => onDragEndSubSection(result)}>
            <Droppable droppableId={654321} key={`droppable-${654321}`}>
              {(provided) => {
                return (
                  <div
                    key={`droppable-div-${654321}`}
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{
                      minHeight: `${7.1 * subsectiondetails?.length}rem`,
                    }}
                  >
                    {subsectiondetails?.map((subSection, i) => {
                      return (
                        <Draggable
                          key={`draggable-${subSection?.subsectionid}`}
                          draggableId={subSection?.subsectionid}
                          index={i}
                        >
                          {(provided) => {
                            return (
                              <SingleMaterial
                                provided={provided}
                                key={`${i}-${subSection?.subsectionid}`}
                                subSection={subSection}
                                sectionid={sectionid}
                                sectionIndex={index}
                                subSectionIndex={i}
                                sectionList={sectionList}
                                setSectionList={setSectionList}
                                totalHoursMain={totalHoursMain}
                                setTotalHoursMain={setTotalHoursMain}
                                totalAmountMain={totalAmountMain}
                                setTotalAmountMain={setTotalAmountMain}
                                vatTotal={vatTotal}
                                setVatTotal={setVatTotal}
                                roleAccess={roleAccess}
                                quoteid={quoteid}
                                mainMargin={margin}
                                mainULaborCost={uLaborCost}
                              />
                            );
                          }}
                        </Draggable>
                      );
                    })}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
          <div
            className="single-sec-cont-head-pro sec-content p-0"
            style={{ cursor: "default" }}
          >
            <div style={{ borderTop: "1px solid white" }}></div>
            <div className="sec-material-div" style={{ position: "relative" }}>
              {/* <p
                style={{ cursor: "pointer" }}
                onClick={() => setShowMaterialPopup(true)}
              >
                Type a material
              </p> */}
              <div
                ref={materialPopupRef}
                className="material-popup"
                style={{
                  transform: showMaterialPopup ? "scale(1)" : "scale(0)",
                  transitionDuration: "300ms",
                }}
              >
                <div className="m-popup-input-div">
                  <input
                    className="material-popup-input"
                    value={material}
                    onChange={(e) => setMaterial(e.target.value)}
                    onFocus={true}
                  />
                  <img
                    src={cross2}
                    onClick={() => setShowMaterialPopup(false)}
                    style={{
                      placeSelf: "end",
                      marginRight: "10px",
                      cursor: "pointer",
                      alignSelf: "center",
                    }}
                  />
                </div>
                <div></div>
                <div class="material-items">
                  {productList?.map((product, index) => {
                    return (
                      <div class="material-items-grid" key={index}>
                        <p
                          className="single-material-item-text"
                          style={{
                            marginTop: "24px",
                            textTransform: "capitalize",
                          }}
                        >
                          {product?.productPartName}
                        </p>
                        <img
                          className="sec-material-img"
                          style={{
                            marginBottom: "0",
                            border: product?.cover
                              ? "0.5px solid #7070704D"
                              : "none",
                            height: !product?.cover && "0",
                          }}
                          src={product?.cover}
                        />
                        <div className="single-material-item-right">
                          <p style={{ marginTop: "24px" }}>Stock</p>
                          {product?.suppliers?.length === 0 ? (
                            <div className="sm-empty-stock">
                              <p>-</p>
                              <div
                                className="material-checkbox"
                                style={{
                                  backgroundColor: "transparent",
                                  boxShadow: "none",
                                }}
                              ></div>
                            </div>
                          ) : (
                            <div className="sm-item-check">
                              <div className="sm-item-check-2">
                                {product?.suppliers?.map((supplier) => {
                                  return (
                                    <div
                                      className="s-m-stock-div"
                                      key={supplier?.productPartSupplierid}
                                    >
                                      <div className="sm-stock">
                                        <div
                                          className="sm-stock-color"
                                          style={{
                                            backgroundColor: `${supplier?.color}`,
                                          }}
                                        ></div>
                                        <p className="sm-stock-text">
                                          {supplier?.instock}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              <div
                                className="material-checkbox"
                                style={{
                                  backgroundColor: selectedProducts?.find(
                                    (product2) =>
                                      product2.productPartid ===
                                      product?.productPartid,
                                  )
                                    ? "#004289"
                                    : "transparent",
                                  boxShadow: selectedProducts?.find(
                                    (product2) =>
                                      product2.productPartid ===
                                      product?.productPartid,
                                  )
                                    ? "0px 3px 6px #34394b29"
                                    : "none",
                                }}
                                onClick={() => {
                                  let list = [...selectedProducts];
                                  let found;
                                  list?.length > 0
                                    ? (found = list.findIndex(
                                        (prod) =>
                                          prod.productPartid ===
                                          productList[index].productPartid,
                                      ))
                                    : (found = false);
                                  if (found >= 0 && found !== false) {
                                    list.splice(found, 1);
                                    return setSelectedProducts([...list]);
                                  }
                                  let item = {
                                    productPartid:
                                      productList[index]?.productPartid,
                                    qty: 0,
                                    unitPrice: Number(
                                      productList[index]?.salePriceexcvat,
                                    ),
                                    materialTotal: 0,
                                    hours: 0,
                                    hoursUnitPrice:
                                      uLaborCost?.length > 0 ? +uLaborCost : 0,
                                    hoursTotal: 0,
                                    margin: margin?.length > 0 ? +margin : 0,
                                    total: 0,
                                    indexPosition: subsectiondetails?.length,
                                  };
                                  list.push(item);
                                  setSelectedProducts([...list]);
                                }}
                              ></div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{ textAlign: "center" }}>
                  <button
                    className="material-add-btn"
                    onClick={() => {
                      if (roleAccess === ROLES.VIEWER)
                        return handleGeneralNotification({
                          notificationType: "CUSTOM",
                          text: `You don't have permission to add/edit quotes.`,
                        });
                      let list = [...selectedProducts];
                      list.map((item, index) => {
                        item["indexPosition"] =
                          subsectiondetails?.length + index;
                      });
                      // dispatch(addSubSection(sectionid, list));
                      setShowMaterialPopup(false);
                      setSelectedProducts([]);
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
          </div>
        </div>
      </div>
    </div>
  );
};

const SingleMaterial = ({
  provided,
  key,
  subSection,
  sectionIndex,
  subSectionIndex,
  sectionList,
  setSectionList,
  setTotalAmountMain,
  setVatTotal,
  roleAccess,
  mainMargin,
  mainULaborCost,
}) => {
  const inputRef = useRef(null);
  const marginRef = useRef(null);
  const [showInput, setShowInput] = useState(false);
  const [margin, setMargin] = useState(subSection?.margin);

  return (
    <div
      className="single-sec-cont-head-pro sec-content p-0"
      key={key}
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <div className="drag-icon ps-3" {...provided.dragHandleProps}>
        <div className="drag-icon-cont">
          <div className="drag-line"></div>
          <div className="drag-line"></div>
        </div>
      </div>
      <div className="sec-material-flex" style={{ cursor: "default" }}>
        <img className="sec-material-img" src={subSection?.cover} />
        <div className="sec-material-div">
          <p>{subSection?.productPartCode}</p>
          <p>{subSection?.productPartName}</p>
        </div>
      </div>
      <div style={{ width: "100%", overflow: "hidden" }}>
        <input
          value={subSection?.qty}
          name="qty"
          type="number"
          placeholder="0"
          onChange={(e) => {
            let list = [...sectionList];
            const { value, name } = e.target;
            let object = list[sectionIndex]?.subSections[subSectionIndex];
            object[name] = Number(value);
            object["metrialTotal"] = Number(value) * subSection?.unitPrice;
            let materialTotal = Number(value) * subSection?.unitPrice;
            object["total"] =
              materialTotal +
              subSection?.hoursTotal +
              ((materialTotal + subSection?.hoursTotal) * margin) / 100;
            list[sectionIndex]?.subSections?.splice(subSectionIndex, 1, object);
            setSectionList([...list]);
            let totalAmount = 0;
            list[sectionIndex]?.subSections?.map((subSection) => {
              totalAmount += +subSection?.total;
            });
            list[sectionIndex]["totalAmount"] = totalAmount;
            setTotalAmountMain(totalAmount);
            let vatTotal2 = 0;
            list?.map((section) => (vatTotal2 += +section.totalAmount));
            setVatTotal(vatTotal2);
            setSectionList([...list]);
          }}
        />
      </div>
      {/* <p style={{ textAlign: "center", fontWeight: "bold" }}>{subSection?.qty}</p> */}
      <p>{europeanFormatWithSymbol(subSection?.unitPrice)}</p>
      <p
        style={{
          fontWeight: "bold",
          backgroundColor: "#FAFAFA",
          width: "100%",
          overflow: "hidden",
        }}
      >
        {europeanFormatWithSymbol(subSection?.metrialTotal)}
      </p>
      <div style={{ width: "100%", overflow: "hidden" }}>
        <input
          value={subSection?.hours}
          name="hours"
          placeholder="0"
          style={{ textAlign: "end" }}
          onChange={(e) => {
            let list = [...sectionList];
            const { value, name } = e.target;
            let object = list[sectionIndex]?.subSections[subSectionIndex];
            object[name] = Number(value);
            object["hoursTotal"] =
              Number(value) * Number(subSection?.hoursUnitPrice);
            object["total"] =
              subSection?.metrialTotal +
              subSection?.hoursTotal +
              ((subSection?.metrialTotal + subSection?.hoursTotal) * margin) /
                100;
            list[sectionIndex]?.subSections?.splice(subSectionIndex, 1, object);
            setSectionList([...list]);
            let totalHours = 0;
            let totalAmount = 0;
            list[sectionIndex]?.subSections?.map((subSection) => {
              totalHours += +subSection?.hours;
              totalAmount += +subSection?.total;
            });
            list[sectionIndex]["totalHours"] = totalHours;
            list[sectionIndex]["totalAmount"] = totalAmount;
            setTotalAmountMain(totalAmount);
            let vatTotal2 = 0;
            list?.map((section) => (vatTotal2 += +section.totalAmount));
            setVatTotal(vatTotal2);
            setSectionList([...list]);
          }}
        />
      </div>
      <div style={{ width: "100%", textAlign: "end", overflow: "hidden" }}>
        <input
          ref={inputRef}
          value={subSection?.hoursUnitPrice}
          style={{
            textAlign: "end",
            fontWeight: "700",
            display: showInput ? "block" : "none",
          }}
          type="number"
          placeholder="0"
          name="hoursUnitPrice"
          onChange={(e) => {
            let list = [...sectionList];
            const { value, name } = e.target;
            let object = list[sectionIndex]?.subSections[subSectionIndex];
            object[name] = Number(value);
            object["hoursTotal"] = Number(value) * Number(subSection?.hours);
            object["total"] =
              subSection?.metrialTotal +
              subSection?.hoursTotal +
              ((subSection?.metrialTotal + subSection?.hoursTotal) * margin) /
                100;
            list[sectionIndex]?.subSections?.splice(subSectionIndex, 1, object);
            setSectionList([...list]);
            let totalAmount = 0;
            list[sectionIndex]?.subSections?.map(
              (subSection) => (totalAmount += +subSection?.total)
            );
            list[sectionIndex]["totalAmount"] = totalAmount;
            setTotalAmountMain(totalAmount);
            let vatTotal2 = 0;
            list?.map((section) => (vatTotal2 += +section.totalAmount));
            setVatTotal(vatTotal2);
            setSectionList([...list]);
          }}
        />
        <p
          onClick={() => {
            if (
              (mainULaborCost?.length > 0 &&
                (ROLES.MANAGER === roleAccess || ROLES.OWNER === roleAccess)) ||
              mainULaborCost?.length === 0
            ) {
              inputRef.current.focus();
              setShowInput(true);
              return;
            } else {
              return;
            }
          }}
          style={{
            display: showInput ? "none" : "block",
            paddingRight: "5px",
            fontWeight: "700",
            marginTop: "6px",
            overflow: "hidden",
          }}
        >
          {europeanFormatWithSymbol(subSection?.hoursUnitPrice)}
        </p>
      </div>
      {/* <p style={{ fontWeight: "bold" }}>{subSection?.hours}</p> */}
      {/* <p>{europeanFormatWithSymbol(subSection?.hoursUnitPrice)}</p> */}
      <p
        style={{
          fontWeight: "bold",
          backgroundColor: "#FAFAFA",
          width: "100%",
          overflow: "hidden",
        }}
      >
        {europeanFormatWithSymbol(subSection?.hoursTotal)}
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <input
          className="margin-input invisible"
          style={{
            width: margin?.length ? `${margin?.length * 10}px` : "30px",
          }}
          ref={marginRef}
          value={margin}
          name="margin"
          onClick={() => {
            if (margin !== 0) return;
            setMargin("");
          }}
          placeholder="0"
          type="number"
          disabled={
            (mainMargin?.length > 0 &&
              (ROLES.MANAGER === roleAccess || ROLES.OWNER === roleAccess)) ||
            mainMargin?.length === 0
              ? false
              : true
          }
          onChange={(e) => {
            let list = [...sectionList];
            const { value, name } = e.target;
            let object = list[sectionIndex]?.subSections[subSectionIndex];
            object[name] = Number(value);
            setMargin(value);
            let total =
              subSection?.metrialTotal +
              subSection?.hoursTotal +
              ((subSection?.metrialTotal + subSection?.hoursTotal) * value) /
                100;
            object["total"] = total;
            list[sectionIndex]?.subSections?.splice(subSectionIndex, 1, object);
            setSectionList([...list]);
            let totalAmount = 0;
            list[sectionIndex]?.subSections?.map(
              (subSection) => (totalAmount += +subSection?.total)
            );
            list[sectionIndex]["totalAmount"] = totalAmount;
            setTotalAmountMain(totalAmount);
            let vatTotal2 = 0;
            list?.map((section) => (vatTotal2 += +section.totalAmount));
            setVatTotal(vatTotal2);
            setSectionList([...list]);
          }}
        />
        <span style={{ marginTop: "6px", visibility: "hidden" }}>%</span>
      </div>
      <p
        style={{
          fontWeight: "bold",
          backgroundColor: "#FAFAFA",
          overflow: "hidden",
        }}
      >
        {europeanFormatWithSymbol(subSection?.total)}
      </p>

      <div
        style={{
          // display: "flex",
          justifyContent: "center",
          gap: "15px",
          backgroundColor: "#CFD9E4",
          height: "100%",
        }}
      >
        <input
          className="text-end"
          type="number"
          placeholder="€ 0,00"
          value={subSection?.realisation}
          onChange={(e) => {
            let list = [...sectionList];
            const { value } = e.target;
            list[sectionIndex].subSections[subSectionIndex].realisation = value;
            setSectionList(list);
          }}
        />
      </div>
    </div>
  );
};
